// hooks/useFeatureFlag.ts
export const useFeatureFlag = (flagName: string): boolean => {
  const envValue = process.env[`REACT_APP_${flagName}`];
  if (envValue === undefined) return false;
  return envValue.toLowerCase() === "true";
};

export const useTurnstileEnabled = (): boolean => {
  return useFeatureFlag("TURNSTILE_ENABLED");
};

export const useTurnstileConfig = () => {
  const isEnabled = useTurnstileEnabled();
  const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY || "";

  return {
    isEnabled,
    siteKey,
    hasSiteKey: !!siteKey,
    isDev: process.env.NODE_ENV === "development",
  };
};
